import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Display from './Display';
import DisplayStatic from './DisplayStatic';
import Customer from './Customer';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Customer />} />
        <Route path="/display" element={<Display />} />
        <Route path="/display-static" element={<DisplayStatic />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
